<template>
	<div class="ReInputMetro" v-if="region && masMetro.length>0">
		<label class="col-form-label col-md-12 "> <span>Метро</span><span class="hohoho"> *обязательно</span></label>
		<div  v-for="(objMetro, obj_index) in value" :key="obj_index">
			<div class="row cc-item align-items-center px-3" >
				
				<el-select v-if="masMetro.length>0"
						class="select-primary mb-1"
						placeholder="Название метро"
						filterable
						clearable
						@change="setMetroName(obj_index)"
						v-model="objMetro.metro_id"
				>
					<el-option
						v-for="(sel_opt, sel_index) in masMetro"
						class="select-primary"
						:value="sel_opt.id"
						:label="sel_opt.name"
						:key="sel_index"
					>
					</el-option>
				</el-select>
				<!-- <label class="col-form-label col-md-12  formRequired"> <span>Как добраться</span></label> -->
				<div class="fieldset-row">
				<div class="fieldset">	
					
					<el-select v-if="masDistanceType.length > 0"
							class="select-primary"
							placeholder="Тип расстояния"
							v-model="objMetro.distanceType"
					>
						<el-option
							v-for="item in masDistanceType"
							class="select-primary"
							:value="item.value"
							:label="item.label"
							:key="item.value"
						>
						</el-option>
					</el-select>
					<base-input					
						:name="errorLabel+'_'+obj_index"
						placeholder="мин"
						required
						v-model="objMetro.distanceToMetro"
						:error="getError(errorLabel+'_'+obj_index)"
						type="number"
					>
					</base-input>
					<!-- <span>{{ errors.first(errorLabel+'_'+obj_index) }}</span> -->
				</div>
				
			
				<div class="btnGroup">
					<button class="ml-2 btn btn-icon btn-simple btn-danger" @click="delMetro(obj_index)">
						<i class="tim-icons icon-trash-simple"></i>
					</button>
				</div>
				</div>
			</div>
		</div>
		
		<button class="btn btn-simple btn-primary" @click="addMetro()" >
			Добавить метро
		</button>
		
	</div>
</template>

<script>
	import {Select, Option} from 'element-ui';
	export default {
		name: 'ReInputMetro',
		components: {
			[Option.name]: Option,
			[Select.name]: Select,
		},
		props: {
			value: {
				type: Array,
				default(){return [{
					metro_id: '',
					metro_name: '',
					distanceType: '',
					distanceToMetro: '',
					// zipal: '',
					// name: '',
					// region: '',
				}];}
			},
			
			delMethod:{
				type: Object,
				default(){return {};}
			},
			// placeholder: [String, Object],
			required:{
				type: Boolean,
				default: false
			},
			errorLabel: String,
			label: String,			
			region:{
				type: String,
				default: '78',
			},
		},
		data () {
			return {
				ver: 1,
				masMetro: [],				
				masDistanceType:[{value: 'TRANSPORT', label: 'транспортом',},{value: 'WALK', label: 'пешком',}],
				distanceToMetro: '',
				isShown: true,
			}
		},
		watch: {
			'region'(val){
				this.getMetro();
			}
		},
		computed: {
			
		},
		methods: {
			setMetroName(val_index){
				for (let i = 0; i < this.masMetro.length; i++) {
					if(this.masMetro[i].id==this.value[val_index].metro_id) 
						this.value[val_index].metro_name = this.masMetro[i].name;
				}
				
			},
			getMetro(){
				let strHregion = '';
				switch (this.region) {
					case '10': // Карелия
					strHregion = '78'; 
						break;
					case '47': //Ленинградская область
					strHregion = '78';
						break;
					case '147': //Ленинградская область
					strHregion = '78';
						break;
					case '77': //Москва // 77, 97, 99, 177, 197, 199, 777, 797, 799, 977
					strHregion = '77';
						break;
					case '50': //Московская область // 50, 90, 150, 190, 250, 550, 750, 790
					strHregion = '77';
						break;
					default:
					strHregion = '78'; //СПБ // 78, 98, 178, 198
						break;
				}
				// console.log('strHregion',strHregion);							
				// console.log('this.region',this.region);				

				let filter = {'list':true,'region':strHregion}; //'region':this.region
				this.$GVO.ApiCall('cat_subway.GET',{flt:{...filter}})
				.then((objApi) => {
					// console.log('cat_subway.GET',objApi);
					if(objApi.success === true){
						if(objApi.data.length > 0){
							this.masMetro = objApi.data;
							// console.log('this.masMetro',this.masMetro);
						}
					}
				}).catch(errorObjApi => console.error(errorObjApi));
			},
			addMetro(){
				this.value.push({
					metro_id: '',
					metro_name: '',
					distanceType: '',
					distanceToMetro: '',
					// zipal: '',
					// name: '',
					// region: '',
				});
			},
			delMetro(ind){
				if(this.value[ind].metro_id != ''){
					if(!this.$GVO.isEmpty(this.delMethod)){
						let apiParam = this.delMethod.apiParam;						
						
						apiParam.flt.metro_id=this.value[ind].metro_id;
						this.$GVO.ApiCall(this.delMethod.apiMethod,apiParam)
							.then((objApi) => {  /*console.log(objApi); console.log('УСПЕШНОЕ УДАЛЕНИЕ КОНТАКТА');*/ })
							.catch((errorObjApi) => {console.error(errorObjApi)});
					}
				}
				this.value.splice(ind,1);
			},			
			getError(fieldName) {
				// console.log(this.errors.first(fieldName));
				return this.errors.first(fieldName);
			},	
		},			
		mounted() {			
			this.getMetro();
		},
		created(){
			
		}
	}
</script>
<style scoped>
	.ReInputMetro .fieldset{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		width: 100%;
	}
	.ReInputMetro .fieldset > *{
		width: 100%; 
		margin-bottom: 0px;
	}
	.ReInputMetro .fieldset:not(.no-select) > div:nth-child(1){width: 250px;}
	.ReInputMetro .btnGroup{
		display: flex;
		align-items: center;
	}
	.cc-item{
		margin-bottom: 7px;
	}
	.ReInputMetro >>> .el-input__inner {font-size: 0.75rem;}
	.ReInputMetro >>> .fieldset > div:nth-child(2) .form-control {height: 38px;}

	.clientExists > *{display: block;}
	.clientExists {display: flex; flex-wrap: wrap;}

	/*Этот код вынесен в src/assets/sass/dashboard/custom/_global.scss т.к. там работает, а тут нет - хз почему*/
	
	/* .ReInputMetro >>> .fieldset > div:nth-child(2) .form-control{border-radius: 0.25rem;} */
	.ReInputMetro >>> .fieldset:not(.no-select) > div:nth-child(1) input{
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
	}
	.ReInputMetro >>> .fieldset > div:nth-child(2) input{
		border-top-left-radius: 0;
		border-bottom-left-radius: 0;
		border-top-right-radius: 0.25rem;
		border-bottom-right-radius: 0.25rem;
	}
	.ReInputMetro >>> .btnGroup .btn.dropdown-toggle[data-toggle="dropdown"]{margin-bottom: 0px !important;}
	.ReInputMetro >>> .fieldset-row {display: flex; width: 100%;}
	.hohoho {color: #F84E54;}

	@media (max-width: 447px) {	
		.ReInputMetro >>> .fieldset-row {flex-wrap: wrap;}
	}
	
</style>
